// aria-label.directive.ts
import { Directive, Input, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appAriaLabel]'
})
export class AriaLabelDirective {
  @Input() set appAriaLabel(value: string) {
    this.renderer.setAttribute(this.el.nativeElement, 'aria-label', value);
  }

  constructor(private el: ElementRef, private renderer: Renderer2) {}
}
